import markdownit from 'markdown-it'
import "../Styles/_content.less"

(function ($) {
    const md = markdownit()
    $('.markdown-body').each(function (i, e) {
        $(e).html(md.render($(e).html()));
        $(e).removeClass('markdown-body');
    });
})(jQuery);